import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TabService } from '../../../../tabconfig/tab.service';
import { MatDialog } from '@angular/material/dialog';
import { EmployeeListComponent } from '../employee-list/employee-list.component';
import { Tab } from '../../../../tabconfig/tab.model';
import { EmployeeService } from '../../../../api/Services/maintenance/employee.service';
import { DialogService } from '../../../../common/dialog.service';
import { AuthService } from '../../../../system/auth.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PersonService } from '../../../../api/Services/maintenance/person.service';

@Component({
  selector: 'app-employee-add',
  templateUrl: './employee-add.component.html',
  styleUrls: ['./employee-add.component.css']
})
export class EmployeeAddComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  @Input() data;
  public editActivo = false;
  public form: FormGroup;
  
  parameters: any[];

  public select_nationality: string;
  public select_type_document: string;
  public select_rol_in_type: string;
  
  constructor(
    private formBuilder: FormBuilder,
    private employeeServices: EmployeeService,
    private personServices: PersonService,
    private toastr: ToastrService,
    private tabService: TabService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private authService: AuthService
  ) { 
    
  }

  ngOnInit(): void {
  this.loadInitial();
    this.initForm();

    this.select_nationality = '';
    this.select_type_document = '';
    this.select_rol_in_type = '';
   

    if(this.data.tabData.element){
      console.log(this.data.tabData.element);
      this.form.setValue(this.data.tabData.element);
      if(this.form.controls['emp_in_status'].value == '1'){
        this.editActivo = true;

        this.select_nationality = this.form.controls['per_in_nationality'].value;
        this.select_type_document = this.form.controls['per_in_document_type'].value;
        this.select_rol_in_type = this.form.controls['rol_in_type'].value;
         
      }
        
    }
  }

  public loadInitial() {
    this.parameters = this.authService.getParameters();
  }
  public initForm() {
    this.form = this.formBuilder.group({
    emp_bi_id: [null],
    per_bi_id: [null],
    per_in_nationality: [null],
    per_in_document_type: [null, Validators.required],
    per_vc_document_type: [null],
    per_vc_document_number: [null, Validators.required],
    per_vc_first_name: [null, Validators.required],
    per_vc_last_name: [null, Validators.required],
    per_vc_full_names: [null],
    per_in_gender: [null],
    per_vc_email: [null, Validators.required],
    per_vc_phone: [null],
    per_vc_cellphone: [null, Validators.required],
    per_vc_ubigeo: [null],
    per_vc_photo:[null],
    emp_in_status:[null],
    emp_vc_status:[null],
    rol_in_type:[null],
    usu_vc_login:[null],
    usu_tx_password:[null]
    });
  }
  

  public guardar() {

    let flagActivado = false;
    if (this.form.valid) {
      if(this.form.controls['emp_bi_id'].value != null){ // si es edición hacer put
       
        this.employeeServices.Update(this.form.getRawValue()).subscribe(data => {
          console.log(data);
        this.form.reset();
        this.toastr.success('Se actualizo correctamente.', 'Correcto');
        this.afterSave();
      });
      }else{ // si es nuevo registro hacer post

        this.dialogService.openConfirmDialog('¿Seguro de guardar este registro?')
          .afterClosed().subscribe(res => {

            if (res) {
              this.LoadingStart(); // Start blocking
              this.employeeServices.Insert(this.form.getRawValue()).subscribe(
                data => {
                  console.log(data);
                  this.LoadingStop();
                  if (data['sucess']) {
                    this.form.reset();
                    this.toastr.success('Se guardo correctamente.', 'Correcto');
                    this.afterSave();
                  }
                  else {
                    this.toastr.warning(data['msg'], 'Advertencia');
                  }
                }
              );
            }
          });

      
      }


    } else {
      this.toastr.warning('Por favor complete los datos del formulario.', 'Advertencia');
    }
  }

  public getpersona() {

    let nationality = this.select_nationality;
    let type_document = this.select_type_document;
    let document_number = this.form.controls['per_vc_document_number'].value; //this.form['per_vc_document_number']
    if (nationality == null) {
      this.toastr.warning('seleccione una nacionalidad por favor.', 'Advertencia');
      return;
    }
    if (nationality == '') {
      this.toastr.warning('seleccione una nacionalidad por favor.', 'Advertencia');
      return;
    }

    if (type_document == null) {
      this.toastr.warning('seleccione un tipo de documento por favor.', 'Advertencia');
      return;
    }
    if (type_document == '') {
      this.toastr.warning('seleccione un tipo de documento por favor.', 'Advertencia');
      return;
    }

    if (document_number == null) {
      this.toastr.warning('ingrese el numero documento por favor.', 'Advertencia');
      return;
    }
    if (document_number == '') {
      this.toastr.warning('ingrese el numero documento por favor.', 'Advertencia');
      return;
    }

    this.dialogService.openConfirmDialog('¿Seguro de buscar a la persona con el numero documento : ' + document_number + '?')
      .afterClosed().subscribe(res => {

        if (res) {
          this.LoadingStart(); // Start blocking
          this.personServices.GetAll(2,+type_document, document_number).subscribe(
            data => {
              console.log(data);
              this.LoadingStop();
              if (data['sucess']) {
                let result = data['data'];
                if (result != null) {
                  if (result.length > 0) {
                    this.form.setValue(result[0]);
                  }
                  else{
                    this.form.controls['per_bi_id'].setValue(null);
                this.form.controls['per_vc_first_name'].setValue(null);
                this.form.controls['per_vc_last_name'].setValue(null);
                this.form.controls['per_vc_email'].setValue(null);
                this.form.controls['per_vc_cellphone'].setValue(null);
                    this.toastr.warning('No se ha encontrado ningun registro', 'Advertencia');
                  }
                }
                else {
                  this.form.controls['per_bi_id'].setValue(null);
                this.form.controls['per_vc_first_name'].setValue(null);
                this.form.controls['per_vc_last_name'].setValue(null);
                this.form.controls['per_vc_email'].setValue(null);
                this.form.controls['per_vc_cellphone'].setValue(null);
                  this.toastr.warning('No se ha encontrado ningun registro', 'Advertencia');
                }

              }
              else {
                this.form.controls['per_bi_id'].setValue(null);
                this.form.controls['per_vc_first_name'].setValue(null);
                this.form.controls['per_vc_last_name'].setValue(null);
                this.form.controls['per_vc_email'].setValue(null);
                this.form.controls['per_vc_cellphone'].setValue(null);
                this.toastr.warning(data['msg'], 'Advertencia');
              }
            }
          );
        }
      });

  }

  public afterSave(){
    this.tabService.removeTab(this.data.id - 1);
    if(this.data.tabData.parent == 'ListadoComponent'){
      this.tabService.addTab(new Tab(EmployeeListComponent, "Listado de Profesor", { parent: 'AppComponent' }));
    }
  }

  public LoadingStart() {
    this.blockUI.start('Cargando...');
  }
  public LoadingStop() {
    this.blockUI.stop();
  }
}
